export enum UnavailableEnergyRootCause {
  Imbalance = 'imbalance',
  WeakCell = 'weak cell',
  LimitingCell = 'limiting cell',
  InoperableString = 'string disconnected',
  InoperablePcsModule = 'pcs module disconnected',
  MissingData = 'missing data',
  InoperableAcCombiner= 'ac combiner not operating',
  Unknown = 'unknown',
}

export enum UnavailableEnergySpecialRecommendedAction {
  BalanceOrTakeOffline = 'balance_or_take_offline',
  ManualInterventionOrTakeOffline = 'manual_intervention_or_take_offline',
  ReplaceOrTakeOffline = 'replace_or_take_offline',
}
